<template>
  <div class="side_content">
    <div
      class="side_item"
      v-for="(tab, index) in tabs"
      :key="index"
      @click="activeTab(index)"
      :class="{ active: isSelected(index) }"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script>
import { i3DBridge } from '@/utils/i3DBridge';
import EventBus from '@/eventBus.ts';
export default {
  name: 'TabSide',
  data() {
    return {
      tabs: [
        {
          code: 'c1',
          name: '主视角',
          isActive: false,
          config: [{ code: '001', viewpoint_code: `dz` }],
        },
        {
          code: 'c1',
          name: '初始化',
          isActive: false,
          config: [{ code: '000', type: `init` }],
        },
        {
          code: 'c1',
          name: '视角切换',
          isActive: false,
          config: [{ code: '001', viewpoint_code: `JK001` }],
        },
        {
          code: 'c2',
          name: '摄像头显示',
          isActive: false,
          config: [{ code: '002', model_code: `all`, type: 'S2', state: 1 }],
        },
        {
          code: 'c2',
          name: '摄像头隐藏',
          isActive: false,
          config: [{ code: '002', model_code: `all`, type: 'S2', state: 0 }],
        },
        {
          code: 'c3',
          name: '故障高亮',
          isActive: false,
          config: [{ code: '003', model_code: [`SLJ001`], type: 'T2', state: 1, color: '-1' }],
        },
        {
          code: 'c3',
          name: '多个高亮',
          isActive: false,
          config: [
            {
              code: '003',
              model_code: ['SLJ001', 'SLJ002', 'SLJ003'],
              type: 'T2',
              state: 1,
              color: '-1',
            },
          ],
        },
        {
          code: 'c3',
          name: '取消高亮',
          isActive: false,
          config: [{ code: '000', type: 'init' }],
        },
        {
          code: 'c4',
          name: '巡检预览',
          isActive: false,
          config: [
            { code: '004', lineId: `07`, patrol_type: '0', state: 'load', time: '', pos: '' },
          ],
        },
        {
          code: 'c4',
          name: '巡检开始',
          isActive: false,
          config: [
            { code: '004', lineId: `07`, patrol_type: '0', state: 'begin', time: '', pos: '' },
          ],
        },
        {
          code: 'c5',
          name: '运转动画播放',
          isActive: false,
          config: [{ code: '005', type: '02', state: 'play' }],
        },
        {
          code: 'c5',
          name: '拆解动画播放',
          isActive: false,
          config: [{ code: '005', type: '03', state: 'play' }],
        },
        {
          code: 'c5',
          name: '组装动画播放',
          isActive: false,
          config: [{ code: '005', type: '04', state: 'play' }],
        },
        {
          code: 'c1',
          name: '动画停止',
          isActive: false,
          config: [{ code: '000', type: `init` }],
        },
        {
          code: 'c6',
          name: '天气-小雨',
          isActive: false,
          config: [{ code: '006', type: 'rain', state: 'small' }],
        },
        {
          code: 'c6',
          name: '天气-大雨',
          isActive: false,
          config: [{ code: '006', type: 'rain', state: 'big' }],
        },
        {
          code: 'c6',
          name: '天气-大雪',
          isActive: false,
          config: [{ code: '006', type: 'snow', state: 'big' }],
        },
        {
          code: 'c6',
          name: '天气-停止',
          isActive: false,
          config: [{ code: '006', type: 'sun', state: '' }],
        },
        {
          code: 'c8',
          name: '昼夜控制-自动',
          isActive: false,
          config: [{ code: '008', type: '', state: 'auto' }],
        },
        {
          code: 'c8',
          name: '昼夜控制-手动',
          isActive: false,
          config: [{ code: '008', type: '', state: 'move' }],
        },
      ],
      tabs2: [
        { code: 'dzcg', name: '电站参观', isActive: false },
        { code: 'dzyw', name: '电站运维', isActive: false },
      ],
      selectedTab: null,
    };
  },
  mounted() {
    console.log('i3dss :>> ', this.$Model);
    EventBus.$on('curSideTabIndex', (data) => {
      console.log('data :>> ', data);
      this.activeTab(data);
    });
  },
  methods: {
    activeTab(index) {
      this.selectedTab = index;
      console.log('this.tabs[index].code) :>> ', this.tabs[index].code);
      // config的赋值参考i3DBridge.js内的各类赋值
      const bridge_config = {
        type: this.tabs[index].code,
        config: this.tabs[index].config,
      };
      i3DBridge(bridge_config);
    },
    isSelected(index) {
      return index === this.selectedTab;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.side_content {
  // width: 150px;
  // background: url('../assets/hs/bg_次级导航背景.png') no-repeat center;
  // position: fixed;
  // left: 650px;
  // background-size: 100% 100%;

  width: 150px;
  position: fixed;
  left: 518px;
  top: 99px;
  background-size: 100% 100%;
  background: #0c2a4e;
  z-index: 99;
  .side_item {
    width: 150px;
    height: 20px;
    line-height: 20px;
    color: $font-color-blue;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin: 15px auto;
    cursor: pointer;
    &.active {
      background: url('../assets/hs/btn次级导航选中.png') no-repeat center;
      color: #fff;
    }
  }
}
</style>
